import component from "./AccountLayout";
export default component;
